export const OverlappedContractsWarningCode = 'OverlappedContractsExist';
